module.exports = __webpack_public_path__ + "static/media/kjøt.4d037124.mp3";